(() => {
  if (!customElements.get("manuals-search")) {
    class ManualsSearch extends HTMLElement {
      constructor() {
        super();
        this.initialise();
      }

      initialise() {
  
        this.strokerSlider = document.querySelector("manuals-slider#strokers") || document.querySelector("manuals-slider#masturbators");
        this.vibratorSlider = document.querySelector("manuals-slider#vibrators");

        this.devices = [];
        document.querySelectorAll("[data-slide]").forEach((device) => {
          this.devices.push({
            name: device.querySelector(".weight-bold").innerHTML,
            index: parseInt(device.getAttribute("data-slide")),
            category: device.parentNode.parentNode.parentNode.getAttribute("id"),
          });
        });
        
        this.searchInput = this.querySelector("[data-search-input]");
        this.matchesDropdown = this.querySelector("[data-matches-dropdown]");
        this.matchesDropdown.style.width = `${this.searchInput.offsetWidth}px`;

        window.addEventListener("resize", () => {
          this.matchesDropdown.style.width = `${this.searchInput.offsetWidth}px`;
        });

        const doSearch = () => {
          const terms = this.searchInput.value.toLowerCase().split(" ");
          this.search(terms);
        };
        this.searchInput.addEventListener("keypress", doSearch);
        this.searchInput.addEventListener("keyup", doSearch);
        this.searchInput.addEventListener("change", doSearch);
        this.searchInput.addEventListener("input", doSearch);

        // Hide/Show the #matches dropdown according to the focus of the input.
        this.searchInput.addEventListener("focusout", () => {
          if (!this.isMatchesMouseDown) {
            this.matchesDropdown.style.display = "none";
          }
        });
        this.searchInput.addEventListener("focusin", () => {
          this.searchInput.dispatchEvent(new Event("select"));
          if (this.searchInput.value !== "") {
            this.matchesDropdown.style.display = "block";
          }
        });
      }
      search(terms) {
        var resultArray = [];
        for (let i = 0; i < this.devices.length; i++) {
          var device = this.devices[i];
          for (let j = 0; j < terms.length; j++) {
            var term = terms[j].toLowerCase();
            if (term === "") {
              continue;
            }

            if (device.name.toLowerCase().indexOf(term) !== -1) {
              if (!resultArray.some((s) => s.index === device.index)) {
                resultArray.push(device);
              } else {
                break;
              }
            }
          }
        }

        // Turn the #matches dropdown off/on according to the number of search results.
        this.matchesDropdown.style.display = resultArray.length > 0 ? "block" : "none";

        // Clear and subsequently populate the #matches dropdown.
        this.matchesDropdown.innerHTML = "";
        for (let i = 0; i < resultArray.length; i++) {
          const match = resultArray[i];
          const div = document.createElement("div");
          div.classList.add("result-item");
          div.innerHTML = match.name;
          div.addEventListener("mousedown", () => {
            this.isMatchesMouseDown = true;
          });
          div.addEventListener("mouseup", () => {
            if (this.isMatchesMouseDown) {
              setTimeout(() => {
                this.matchesDropdown.style.display = "none";
              }, 100);

              if (match.category === "strokers") {
                if(this.vibratorSlider) {
                  this.vibratorSlider.collapseAll();  
                }                
                if(this.strokerSlider) {
                  this.strokerSlider.focusSlide(match.index);
                }
                
              } else {
                if(this.strokerSlider) {
                  this.strokerSlider.collapseAll();
                }
                if(this.vibratorSlider) {
                  this.vibratorSlider.focusSlide(match.index);
                }
              }
              this.searchInput.value = "";
            }
            this.isMatchesMouseDown = false;
          });
          this.matchesDropdown.appendChild(div);
        }
      }
    }

    customElements.define("manuals-search", ManualsSearch);
  }
})();
